import { useEffect } from "react";
import styles from "../styles/login.module.css";

// The "landing" page is just a redirect to /dashboard. /dashboard* is served
// by the SPA from S3 (CloudFront default behavior) — ztc-core never sees it.
// Auth is driven by DashboardShell calling /api/me and redirecting to
// /oauth2/authorization/cognito on 401; Spring's defaultSuccessUrl sends the
// user back to /dashboard after login, then React Router routes to overview.
//
// Using window.location.replace so the SPA root doesn't end up in history.
const REDIRECT_TARGET = "/dashboard";

export const Login = (): JSX.Element => {
  useEffect(() => {
    window.location.replace(REDIRECT_TARGET);
  }, []);

  return (
    <main className={styles.wrap}>
      <p className={styles.redirecting}>Redirecting…</p>
      <noscript>
        <p>
          JavaScript is disabled. <a href={REDIRECT_TARGET}>Continue to dashboard</a>.
        </p>
      </noscript>
    </main>
  );
};
